import { IMdCmSearchFields } from "../types/ScmTypes";
import { MdEnableStatusEnum } from "../types/ScmEnums";

//系统标识
export const CLIENT_APP_CODE = "vrm-nga";

export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 10000;
//API请求环境
const baseRequestUrl = {
    "DEV": "http://api.peijian88.cn/ngavrm-s",
    //"TEST": "http://api-2.laoniuche.cn/ngavrm-s",
    "TEST": "https://test-api-2.laoniuche.cn/ngavrm-s",
    // "TEST" : "http://api.laoniuche.club/ngavrm-s",
    "PROD": "https://api-2.yunhaogroup.com/ngavrm-s",
    "STAGE": "http://api.beiben88.com/ngavrm-s",
}
//鉴权2.0的请求环境
const baseAuth2RequestUrl = {
    "DEV": "http://api.peijian88.cn",
    //"TEST": 'http://api-2.laoniuche.cn',
    "TEST": 'https://test-api-2.laoniuche.cn',
    // "TEST": `http://api.laoniuche.club`,
    "PROD": 'https://api-2.yunhaogroup.com',
    "STAGE": "http://api.beiben88.com",
}
//这里设置根据本地运行或打包时，通过不同命令可以知道是运行的哪个国家的接口地址
//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取鉴权请求地址
export const getBaseAuth2RequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    return baseAuth2RequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";
//获取token
export const getToken = () => {
    return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};
//存储token
export const setToken = (token: string) => {
    sessionStorage.setItem(TOKEN_KEY, token)
};
//主数据通用字段定义
export const defaultMdCmParam: IMdCmSearchFields = {
    sourceApp: "scm-v2.0",
    sourceAuthKey: "",
    branch: "main",
    ver: undefined,
    enable: MdEnableStatusEnum.ENABLE,
};
//财务通用字段定义
export const defaultMdCmParamAccout: IMdCmSearchFields = {
    sourceApp: "vrm-nga-s",
    sourceAuthKey: "",
    branch: "vrm-nga-s",
};
//设置基础数据的分支
let IsystemCode: any = {
    // "TEST": "vrm-sa",
    "TEST": "vrm-nga-s",
    // "PROD": "vrm-sa",
    "PROD": "vrm-nga-s"
}
const REACT_APP_ENV = process.env.REACT_APP_ENV as string
export let mianCode = IsystemCode[REACT_APP_ENV]
export const branchDs = [
    { label: "财务分支", value: "fms" },
    { label: "主分支", value: "main" },
    { label: "供应链分支", value: "scm" },
    { label: "云修分支", value: "vrm" },
]